@if ((productLoading$ | async) === false) { @if (product$ | async; as product) {
<section class="product-details">
  <bau365-product-section-header
    [product]="product"
    [fairId]="(fairId$ | async) ?? undefined"
    [breadcrumbElements]="breadcrumbElements"
    [isPlatformFair]="(isBauInsights$ | async) === true"
    [featureProductAtBooth]="(featureProductAtBooth$ | async) === true"
    (swiperInteraction)="swiperInteraction($event)"
    (shareButtonDialogOpen)="openShareButtonDialog($event)"></bau365-product-section-header>
  @if (exhibitor$ | async; as exhibitor) {
  <bau365-product-section-exhibitor-info
    [product]="product"
    [exhibitor]="exhibitor"
    [size]="size"></bau365-product-section-exhibitor-info>
  }
  <section class="product-details-wrapper">
    <bau365-product-section-key-facts [key_facts]="product.key_facts"></bau365-product-section-key-facts>
    <bau365-product-section-info [fairId]="product.fair_id" [product]="product"></bau365-product-section-info>
    <bau365-product-section-country-availability
      [countries]="product.countries"
      (modalOpened)="openCountryAvailabilityModal()"></bau365-product-section-country-availability>
    <bau365-product-section-media
      [product]="product"
      (tabChange)="tabChange($event)"
      (download)="trackDownload($event.element, $event.fileName)"
      (linkClick)="
        trackClick($event.element, $event.linkType, $event.linkText, $event.contactPersonId)
      "></bau365-product-section-media>
    <bau365-product-section-contact-persons
      [product]="product"
      [exhibitor]="exhibitor"
      [size]="size"
      (linkClick)="
        trackClick($event.element, $event.linkType, $event.linkText, $event.contactPersonId)
      "></bau365-product-section-contact-persons>
    <bau365-product-section-product-references
      [products]="referencedProducts ?? undefined"
      [exhibitor]="exhibitor"
      [size]="size"
      [cardSliderConfig]="cardSliderConfig$ | async"></bau365-product-section-product-references>
  </section>
</section>
} @else { @if ((productError$ | async) !== '500') {
<bau365-shell-page-not-found></bau365-shell-page-not-found>
} @if ((productError$ | async) === '500') {
<bau365-shell-page-service-unavailable></bau365-shell-page-service-unavailable>
} } } @else {
<section class="loading-animation">
  <planone-loading-animation></planone-loading-animation>
</section>
}
<ng-template #shareButtonsTitle>
  <span i18n="@@featureProductsDetails-socialShareTitle">Teilen</span>
</ng-template>
<ng-template #shareButtons>
  <planone-share-buttons
    [url]="socialShareUrl"
    [emailSubject]="emailSubject"
    [emailBody]="emailBody"
    (shareButtonClicked)="shareButtonClick($event)"></planone-share-buttons>
</ng-template>
<ng-template #loading>
  <section class="loading-animation">
    <planone-loading-animation></planone-loading-animation>
  </section>
</ng-template>
